"use strict" /* eslint-disable no-console, no-unused-vars */;

/**
 * homepageHero shows and hides form elements
 * when there are two toggleable form options.
 * Initialize and pass an object with a
 * toggle and its target's classnames in our app's entrypoint
 */

const homepageHero = (function() {
  const heroData = document.querySelector(".js-hero-data");
  const heroVariants = document.querySelectorAll(".js-hero-variant");
  const heroContainer = document.querySelector(".js-hero-container");
  // nothing to do here
  if ([heroData, heroVariants, heroContainer].filter(Boolean) < 3) {
    return;
  }
  let heroOptions = [];

  /**
   * removeElFromDOM
   *
   * helper to remove element from DOM
   *
   * @param el: target element
   */
  function removeElFromDOM(el) {
    if (el && el.parentNode) {
      return el.parentNode.removeChild(el);
    }
  }

  /**
   * randomInt
   *
   * return random integer less than number of hero variants in WP
   */
  function randomInt() {
    return Math.floor(Math.random() * heroVariants.length);
  }

  /**
   * randomizeHero
   *
   * randomize hero option from available variants in WP
   * and update the DOM
   */
  function randomizeHero() {
    heroVariants.forEach((hero) => {
      heroOptions.push({
        imgMobile: hero.dataset.heroImgMobile,
        imgDesktop: hero.dataset.heroImgDesktop,
        imgCredit: hero.dataset.heroImgCredit,
        title: hero.dataset.heroTitle,
        desc: hero.dataset.heroDesc,
        ctaLink: hero.dataset.heroCtaLink,
        ctaText: hero.dataset.heroCtaText,
        ctaNewTab: hero.dataset.heroCtaNewTab,
      });
    });

    // clean up WP hero data from DOM
    removeElFromDOM(heroData);

    const selectedHero = heroOptions[randomInt()];
    if (!selectedHero) {
      return;
    }
    const heroDesc = heroContainer.querySelector(".js-hero-description");
    const heroCta = heroContainer.querySelector(".js-hero-cta");
    const heroImgCredits = heroContainer.querySelectorAll(
      ".js-hero-img-credit"
    );

    // DOM updates for required fields
    heroContainer.querySelector(".js-hero-img-src").src =
      selectedHero.imgDesktop;
    heroContainer.querySelector(".js-hero-source-srcset-desktop").srcset =
      selectedHero.imgDesktop;
    heroContainer.querySelector(".js-hero-source-srcset-mobile").srcset =
      selectedHero.imgMobile;
    heroContainer.querySelector(".js-hero-title").textContent =
      selectedHero.title;

    // DOM updates for optional fields
    selectedHero.desc.length
      ? (heroDesc.textContent = selectedHero.desc)
      : heroDesc.parentNode.removeChild(heroDesc);

    if (selectedHero.ctaLink.length && selectedHero.ctaText.length) {
      heroCta.href = selectedHero.ctaLink;
      heroCta.textContent = selectedHero.ctaText;
      if (selectedHero.ctaNewTab) {
        heroCta.target = "_blank";
      }
    } else {
      removeElFromDOM(heroCta);
    }

    selectedHero.imgCredit.length
      ? heroImgCredits.forEach(
          (credit) => (credit.innerHTML = `Image: ${selectedHero.imgCredit}`)
        )
      : heroImgCredits.forEach((credit) => removeElFromDOM(credit));
  }

  /**
   * addClassWithDelay
   *
   * Helper method to add new class w/ delay
   * to hide the hero animation
   *
   * @param target: DOM element
   * @param className: string
   * @param delay: integer
   */
  function addClassWithDelay(target, className, delay) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        target.classList.add(className);
        resolve();
      }, delay);
    });
  }

  /**
   * coverOpen
   *
   * return random integer less than number of slide
   */
  function coverOpen() {
    const hero = document.querySelector(".homepage-hero");
    const heroCover = document.querySelector(".homepage-hero__cover");
    const heroContent = document.querySelector(".homepage-hero__content");

    if ([hero, heroCover, heroContent].filter(Boolean) < 3) {
      return;
    }

    addClassWithDelay(heroCover, "is-hidden", 2700)
      .then(() => {
        addClassWithDelay(heroContent, "is-visible", 500);
      })
      .then(() => {
        addClassWithDelay(hero, "overflow-visible", 2000);
        addClassWithDelay(heroCover, "visually-hidden", 2000);
      });
  }

  /**
   * loadedClass
   *
   * Syncs the active toggle to its target element
   * and adds/removes state classes accordingly
   *
   * @param activeToggle: clicked toggle
   */
  function loadedClass() {
    window.addEventListener("DOMContentLoaded", () => {
      const els = document.querySelectorAll(".js-loaded-class");

      [].forEach.call(els, (el) => {
        el.classList.add("loaded");
      });

      coverOpen();
    });
  }

  /**
   * init
   *
   * Listens for click events and passes through
   * a settings object to the click handler
   *
   * @param settings: object with a toggle and its target's classnames
   */
  function init() {
    if (document.querySelector(".homepage-hero")) {
      randomizeHero();
      loadedClass();
    }
  }

  init();
})();

export default homepageHero;



// WEBPACK FOOTER //
// ./resources/assets/js/homepage-hero.js